import styled from 'styled-components';
import { Typography, Card, Button, Row } from 'antd';
import { COLORS } from '../../constants/colors';

const { Title, Paragraph } = Typography;

export const HomeContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const LogoContainer = styled.div`
  
  img {
    max-width: 200px;
    height: auto;
  }
  
  @media (max-width: 768px) {
    margin-bottom: 20px;
    
    img {
      max-width: 220px;
    }
  }
`;

export const StyledTitle = styled(Title)`
  color: ${COLORS.PRIMARY_TIFFANY};
  
  @media (max-width: 768px) {
    font-size: 22px !important;
  }
`;

export const IntroText = styled(Paragraph)`
  &&& {
    font-size: 18px;
    max-width: 800px;
    margin: 0 auto 40px;
  }
`;

export const LoadingContainer = styled.div`
  text-align: center;
  margin: 40px 0;
`;

export const LoadingText = styled.p`
  margin-top: 16px;
  color: #666;
`;

export const EventsRow = styled(Row)`
  margin-bottom: 40px;
`;

export const EventContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const EventTitle = styled(Title)`
  &&& {
    margin: 0;
    color: #2c3e50;
    font-size: 18px;
  }
`;

export const EventDescription = styled(Paragraph)`
  &&& {
    font-size: 14px;
    color: #666;
    margin-bottom: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: left;
  }
`;

export const EventMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  
  .anticon {
    color: ${COLORS.PRIMARY_TIFFANY};
  }
`;

export const EventFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #999;
`;

export const EmptyEventsContainer = styled.div`
  text-align: center;
  margin: 40px 0;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 12px;
`;

export const EmptyEventsIcon = styled.div`
  .anticon {
    font-size: 48px;
    color: #ccc;
    margin-bottom: 16px;
  }
`;

export const EmptyEventsTitle = styled(Title)`
  &&& {
    color: #666;
    margin: 0 0 8px 0;
  }
`;

export const EmptyEventsText = styled(Paragraph)`
  &&& {
    color: #999;
    margin: 0;
  }
`;

export const FormsRow = styled(Row)`
  margin-top: 40px;
`;

export const StyledCard = styled(Card)`
  height: 100%;
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 2px solid ${props => props.bordercolor};
  text-align: left;
  
  &:hover {
    transform: translateY(-6px);
  }
  
  && {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .ant-card-head {
    background-color: ${props => props.headcolor};
    color: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 16px;
    flex-shrink: 0;
  }
  
  .ant-card-head-title {
    color: white;
    font-size: 20px;
    font-weight: 600;
  }
  
  .ant-card-body {
    padding: 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;

export const CardIcon = styled.div`
  font-size: 48px;
  margin-bottom: 20px;
  color: ${props => props.color || COLORS.PRIMARY_TIFFANY};
  text-align: center;
`;

export const CardDescription = styled(Paragraph)`
  &&& {
    font-size: 16px;
    text-align: left;
    margin-bottom: 16px;
  }
`;

export const CardDetails = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const CardDetailText = styled(Paragraph)`
  &&& {
    font-size: 14px;
    text-align: left;
    color: #666;
  }
`;

export const CardButtonContainer = styled.div`
  text-align: center;
  margin-top: auto;
  padding-top: 16px;
`;

export const ActionButton = styled(Button)`
  height: 48px;
  font-size: 14px;
  font-weight: 600;
  color: white !important;
  border-radius: 24px;
  padding: 0 28px;
  background-color: ${props => props.bgcolor} !important;
  border-color: ${props => props.bgcolor} !important;
  box-shadow: none !important;
  
  &:hover, &:focus {
    background-color: ${props => props.hovercolor} !important;
    border-color: ${props => props.hovercolor} !important;
    color: white !important;
    box-shadow: none !important;
  }
  
  .anticon {
    margin-left: 8px;
    color: white !important;
  }
`;

export const EventCard = styled(Card)`
  height: 100%;
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 2px solid #e8e8e8;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-4px);
    border-color: ${COLORS.PRIMARY_TIFFANY};
  }
  
  .ant-card-body {
    padding: 20px;
  }
`;

export const EventStatus = styled.span`
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  background: ${props => {
    switch (props.status) {
      case 'upcoming': return '#fff3cd';
      case 'active': return '#d4edda';
      case 'completed': return '#d1ecf1';
      default: return '#f8f9fa';
    }
  }};
  color: ${props => {
    switch (props.status) {
      case 'upcoming': return '#856404';
      case 'active': return '#155724';
      case 'completed': return '#0c5460';
      default: return '#666';
    }
  }};
`;

export const SectionTitle = styled(Title)`
  color: #2c3e50;
  margin: 40px 0 24px 0 !important;
  text-align: left;
  
  &::after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background: ${COLORS.PRIMARY_TIFFANY};
    margin-top: 8px;
  }
  
  @media (max-width: 768px) {
    text-align: left !important;
  }
`;

export const FooterText = styled(Paragraph)`
  &&& {
    font-size: 14px;
    color: #666;
  }
`;
